<script lang="ts">
    import { Label, Select, Toggle, Helper as HelperComponent, Kbd, Tooltip } from "flowbite-svelte";
    import posthog from "posthog-js";
    import type { Options, TempStateType } from "../types";
    import { allThemes, State, TempState } from "../state.svelte";
    import { Helper } from "../helpers";
    import ColoredModal from "../colored/ColoredModal.svelte";
    import ColoredButton from "../colored/ColoredButton.svelte";
    import { onMount } from "svelte";

    let {isOpen = $bindable(), closeSidebar}: { isOpen: boolean, closeSidebar: () => void } = $props();

    let updatedOptions: Options | null = $state(null);

    let updatedTempState: TempStateType | null = $state(null);

    const themeOptions = allThemes.map(theme => {
        const name = theme.toString()[0].toUpperCase() + theme.toString().slice(1).toLowerCase();

        return {
            value: theme.toString(),
            name: name
        };
    });

    onMount(() => {
        updatedOptions = {...State.options};

        updatedTempState = {...TempState};
    });

    function save() {
        if (updatedOptions === null || updatedTempState === null) return;

        if (!updatedTempState.upsideDown && TempState.upsideDown) {
            window.location.reload();
        }

        Helper.forceTheme(updatedOptions.theme);
        State.options.darNotifications = updatedOptions.darNotifications;
        State.options.keyboardShortcuts = updatedOptions.keyboardShortcuts;
        Helper.setUpsideDown(updatedTempState.upsideDown);
        posthog.capture('settings_saved', {
            theme: updatedOptions.theme,
            dar_notifications: updatedOptions.darNotifications,
            keyboard_shortcuts: updatedOptions.keyboardShortcuts,
            upside_down: updatedTempState.upsideDown,
        });
        cancel();
        closeSidebar();
    }

    function reset() {
        Helper.resetOptionsToDefault();
        posthog.capture('settings_reset_to_default');
        cancel();
        closeSidebar();
    }

    function cancel() {
        isOpen = false;
    }

</script>

{#if updatedOptions !== null && updatedTempState !== null}
    <div class="z-51 absolute top-0 left-0 w-full h-full {!isOpen ? 'hidden' : ''}">
        <ColoredModal title="Settings" bind:open={isOpen} onclose={cancel} class="min-w-full">
            <form class="[&_label]:frappe:text-ctp-subtext0 [&_label]:black:text-gray-200">
                <div class="grid gap-4 mb-2 sm:grid-cols-2">
                    <div>
                        <Label>Theme</Label>
                        <Select class="mt-2 select-no-focus frappe:bg-ctp-pink outline-none border-none"
                                items={themeOptions}
                                bind:value={updatedOptions.theme}
                                required/>
                    </div>
                    <div>
                        <Label for="name" class="mb-2">Dar Notifications</Label>
                        <Toggle bind:checked={updatedOptions.darNotifications}
                                class="toggle-no-focus"
                                classDiv="frappe:peer-checked:bg-ctp-teal black:peer-checked:bg-gray-500 black:bg-gray-800">{updatedOptions.darNotifications ? "On" : "Off"}</Toggle>
                    </div>
                    <div>
                        <Label id="hm-label" for="name"
                               class="mb-2">{!TempState.upsideDown ? "Hard Mode" : "It's actually upside down mode haha"}</Label>
                        <div id="hm-toggle">
                            <Toggle bind:checked={updatedTempState.upsideDown}
                                    class="toggle-no-focus"
                                    classDiv="frappe:peer-checked:bg-ctp-teal black:peer-checked:bg-gray-500 black:bg-gray-800">{updatedTempState.upsideDown ? "On" : "Off"}</Toggle>
                        </div>
                    </div>
                    <div>
                        <Label id="kb-label" for="kb-toggle" class="mb-2 w-fit underline">Keyboard Shortcuts</Label>
                        <Tooltip>Use the spacebar and backspace keys to increment and decrement the counter</Tooltip>
                        <Toggle bind:checked={updatedOptions.keyboardShortcuts}
                                class="toggle-no-focus"
                                classDiv="frappe:peer-checked:bg-ctp-teal black:peer-checked:bg-gray-500 black:bg-gray-800">{updatedTempState.upsideDown ? "On" : "Off"}</Toggle>
                    </div>
                </div>
            </form>
            {#snippet footer()}
                <div class="flex w-full justify-between">
                    <div class="flex gap-2">
                        <ColoredButton color="green" onclick={save}>Save</ColoredButton>
                        <ColoredButton onclick={cancel}>Cancel</ColoredButton>
                    </div>
                    <ColoredButton onclick={reset} color="red">Reset to default</ColoredButton>
                </div>
            {/snippet}
        </ColoredModal>
    </div>
{/if}